import { RouterConfig } from "@shared/lib/routerConfig";

export const PRIVATE_ROUTES = [
    RouterConfig.PROFILE,
    RouterConfig.PROFILE_COMPANY,
    RouterConfig.MY_ADS,
    RouterConfig.VIEWED_ADS,
    RouterConfig.CREATE_OFFER,
    RouterConfig.HISTORY_MY_REPORTS,
    RouterConfig.HISTORY_REPORT
];

export const PUBLIC_EXCEPTIONS = [RouterConfig.MAIN, RouterConfig.HISTORY];